import { Helmet } from "react-helmet";
import { Box, Typography, Card, CardContent } from "@mui/material";
import Sidebar from "../../sidebar/sidebar";
import OfflineTransfer from "./components/offlineTransfer";
import { useAppStore } from "../../../appStore";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

function TransferOnlinePage() {
  const { profileData } = useAppStore();

  return (
    <>
      <Helmet>
        <title>S - M ( M-India ) Spot-Money | Offline Transfer</title>
      </Helmet>
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 1,
            background: `url(${process.env.PUBLIC_URL}/images/logo-background.png) center/250px no-repeat fixed`,
            minHeight: "100vh",
          }}
        >
          <Box height={{ xs: 60, md: 90 }} />
          {profileData?.offlineTansferStatus === "inactive" ? (
            <Card
              sx={{
                maxWidth: 500,
                mx: "auto",
                mt: 4,
                p: 2,
                backgroundColor: "#fff3e0",
                borderLeft: "6px solid #ff9800",
                boxShadow: 3,
                borderRadius: 2,
              }}
            >
              <CardContent sx={{ textAlign: "center" }}>
                <WarningAmberIcon sx={{ fontSize: 50, color: "#ff9800" }} />
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", mt: 2, color: "#e65100" }}
                >
                  Offline Transfer Disabled
                </Typography>
                <Typography variant="body1" sx={{ mt: 1, color: "#795548" }}>
                  Your Offline transfer access is currently{" "}
                  <strong>inactive</strong>. Please contact support or your
                  administrator for assistance.
                </Typography>
              </CardContent>
            </Card>
          ) : (
            <OfflineTransfer />
          )}
        </Box>
      </Box>
    </>
  );
}

export default TransferOnlinePage;
